import * as React from 'react'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import Dialog from '@material-ui/core/Dialog'

export class SuccessDialog extends React.PureComponent {
  props: {
    open: boolean
    onClose: any
    tubeColor: string
    dialogContent: string
    header: string
  }

  render() {
    const { dialogContent, tubeColor, header, ...other } = this.props

    return (
      <Dialog maxWidth="md" aria-labelledby="confirm-dialog" {...other}>
        <DialogTitle id="confirm-dialog">
          <span style={{ color: tubeColor }}>{header}</span>
        </DialogTitle>

        <DialogContent>
          <p>{dialogContent}.</p>
        </DialogContent>
      </Dialog>
    )
  }
}
